module.exports = __webpack_public_path__ + "static/media/back.8376d257.svg";